export default __webpack_public_path__ + "static/media/mock-ups.a513cbf8.png";